import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import {
  AdminMandant,
  Area, DeactivationTicket,
  Duplicate,
  Employee,
  EmployeeDetails, EmployeeUpdateDetails, K2HelpEmployeeTicketData,
  OrgUnitSetting, UserRightsDisableReasonModel
} from '../../models/cloud/cloud.model';
/** Injection token for the data service */
export const CLOUD_DATA_SERVICE = new InjectionToken<CloudDataService>('[Cloud] CloudDataService');

export interface CloudDataService {
  getAdminMandants(): ObservableResult<AdminMandant[]>;
  getOrgUnitSettings(mandantId: number): ObservableResult<OrgUnitSetting[]>;
  saveOrgUnitSetting(setting: OrgUnitSetting): ObservableResult<void>;
  deleteOrgUnitSetting(id: number): ObservableResult<void>;
  getAreas(mandantId: number): ObservableResult<Area[]>;
  saveArea(area: Area): ObservableResult<void>;
  deleteArea(mandantId: number, num: number): ObservableResult<void>;
  getEmployees(mandantId: number): ObservableResult<Employee[]>;
  getDuplicates(mandantId: number): ObservableResult<Duplicate[]>;
  getEmployee(employeeId: number, mandantId: number): ObservableResult<EmployeeDetails>;
  updateEmployee(employee: EmployeeUpdateDetails, mandantId: number): ObservableResult<void>;
  getUserRightsDisableReasons(): ObservableResult<UserRightsDisableReasonModel[]>;
  getK2HelpEmployeeData(): ObservableResult<K2HelpEmployeeTicketData[]>;
  submitDeactivationTicket(ticket: DeactivationTicket): ObservableResult<void>;
}
